import React from 'react';
import EventTypeAttributeSidebar from 'app/containers/Sidebars/EventTypeAttributeSidebar';

import { buildSidebar as buildSidebarAction, closeSidebar as closeSidebarAction } from 'store/actions/sidebar/sidebarActions';

export const openEventTypeAttributeSidebar = ({ title, subTitle, attributeId, attributeIcon }) => async (dispatch, getState) => {
    return buildSidebarAction({
        title,
        subTitle,
        content: (
            <EventTypeAttributeSidebar
                attributeId={attributeId}
                title={title}
                attributeIcon={attributeIcon}
            />
        ),
        isOpen: true,
    })(dispatch, getState);
};

export const closeEventTypeAttributeSidebar = closeSidebarAction;